import { TransportManagementReport } from '../state/monitoring/transport-management-profile/models';
import { AutomotiveAftermarketReport } from '../state/monitoring/automotive-aftermarket-profile/models/automotive-aftermarket-report.model';
import { ShipmentProfileReport } from '../state/monitoring/shipment-planner-profile';
import { ShipmentReportName } from '../state/monitoring/shipment-planner-profile/constants/shipment-planner-profile-report.constant';
import { TransportManagementReportName } from '../state/monitoring/transport-management-profile';
import { AutomotiveAftermarketReportName } from '../state/monitoring/automotive-aftermarket-profile';
import { FormBuilder, FormControl } from '@angular/forms';

export enum ReportType {
  Delay = 'DELAY',
  Early = 'EARLY',
  Both = 'BOTH',
}

export enum DelayTypeValue {
  Sea = 24,
  Road = 5,
  Air = 6,
}

export interface ProfileReportItem {
  value: string;
  title: string;
  required: boolean;
  isSelected: boolean;
}

export type ProfileReport = TransportManagementReport | AutomotiveAftermarketReport | ShipmentProfileReport;

export type ProfileReportNames = ShipmentReportName | TransportManagementReportName | AutomotiveAftermarketReportName;

export class TransportManagementProfileReport {
  load: ProfileReportItem[] = [];
  to: ProfileReportItem[] = [];
  type: ReportType = ReportType.Delay;

  constructor(params?: TransportManagementProfileReport) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class TransportManagementProfileReportForm {
  constructor(
    model: Partial<TransportManagementProfileReport>,
    fb: FormBuilder = new FormBuilder(),
    public load: FormControl<ProfileReportItem[]> = fb.control<ProfileReportItem[]>(model.load, []),
    public to: FormControl<ProfileReportItem[]> = fb.control<ProfileReportItem[]>(model.to, []),
    public type: FormControl<ReportType> = fb.control<ReportType>(model.type, []),
  ) {}
}
